import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { InvoiceManualFilter } from '../models/filters/invoice-manual-filter';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseModel } from '../models/response-model';
import { InvoiceManual } from '../models/invoice-manual';
import { Paging } from '../models/page';

@Injectable({
  providedIn: 'root'
})
export class InvoicesManualService {

  constructor(private http: HttpClient) { }
  private url = `${environment.url}/mtInvoices`;


  readInvoices(invoiceFilter: Filter<InvoiceManualFilter>) {
    let params = new HttpParams();
    params = params
      .set("page", invoiceFilter.page.toString() || "0")
      .set("pageSize", invoiceFilter.pageSize.toString() || "20");

    params = invoiceFilter.value.invoiceNumber ? params.set("invoiceNumber", invoiceFilter.value.invoiceNumber) : params;
    params = invoiceFilter.value.cai ? params.set("cai", invoiceFilter.value.cai) : params;
    params = invoiceFilter.value.salesOrg ? params.set("salesOrg", invoiceFilter.value.salesOrg) : params;
    return this.http.get<ResponseModel<Paging<Array<InvoiceManual>>>>(`${this.url}`, { params });
  }
}
